export const UI_SET_CURRENT_PAGE = "UI_SET_CURRENT_PAGE";
export const UI_SET_SIDEBAR_COLLAPSED = "UI_SET_SIDEBAR_COLLAPSED";
export const UI_SET_CURRENT_LOCALE = "UI_SET_CURRENT_LOCALE";
export const UI_SHOW_NOTIFICATION = "UI_SHOW_NOTIFICATION";
export const UI_HIDE_NOTIFICATION = "UI_HIDE_NOTIFICATION";

export const UI_SET_SIDEBAR_OPEN = "UI_SET_SIDEBAR_OPEN";
export const UI_SET_MODAL_OPEN = "UI_SET_MODAL_OPEN";
export const UI_SET_LOADING = "UI_SET_LOADING";
export const UI_SET_THEME = "UI_SET_THEME";
export const UI_SET_MOBILE_VIEW = "UI_SET_MOBILE_VIEW";

export const MODAL_TYPES = {
  APPOINTMENT_DETAILS: "appointment_details",
  BOOK_APPOINTMENT: "book_appointment",
  EDIT_APPOINTMENT: "edit_appointment",
  CONFIRM_DELETE: "confirm_delete",
  AGENDA_SETTINGS: "agenda_settings",
};
